import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'report-edit',
  data: function () {
    return {
      linkCallBack: function(){},  // リンク用コールバック
      utils:                utils,
      shopId:               null,  // 店舗
      patientId:            null,  // 患者D    ※詳細画面から遷移時に指定されます.
      reportId:             null,  // 報告書ID ※詳細画面から遷移時に指定されます.
      facilityId:           null,  // 施設ID（クリニックID、介護支援事業所ID）
      type:                 null,  // 施設・医療機関タイプ  ※報告書送信履歴からの遷移時に指定されます.
      patientName:          null,  // 患者名
      word50:               '',    // 50音
      patientIndex:         0,     // 患者インデックス
      reportHistNo:         0,     // 報告書履歴番号
      phraseTypeId:         1,     // 定型文
      phraseSort:           0,     // 定型文ソート
      phraseTargetElm:      null,  // 定型文設定対象要素
      phraseSaveIds:        '',    // 定型文保存用
      printDeliveryDate:    '',    // 印刷日
      searchCallbackFlag:   false, // 検索結果フラグ
      bulkDate:             '',    // 日付一括
      bulkDateType:         1,     // 日付一括タイプ
      sokujiSendTimingHour: null,  // 即時提出モーダル用
      isHeaderOpen:         true,  // ヘッダー開閉状態
      isSmartPhone:         false, // スマホ確認用
      isCheckRoomNo:        true,  // チェックボックス 表示項目 部屋番号
      isCheckHaiyaku:       true,  // チェックボックス 表示項目 配薬内容
      isCheckHenkou:        true,  // チェックボックス 表示項目 変更点
      isCheckShidou:        true,  // チェックボックス 表示項目 指導内容
      isCheckKakunin:       true,  // チェックボックス 表示項目 確認事項
      isConfirm:            false, // 確認用
      isTakingListShow:     false, // 配薬内容 処方日数
      isDeliListShow:       false  // 今回配薬内容 処方日数
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    // 店舗切替
    if (utils.isPresent(to)) {
      if (window.localStorage.getItem('shop_id') === null || window.localStorage.getItem('shop_id') === 'null') {
        if (to.fullPath === '/shops') {
          // 他店舗切替に遷移
          utils.stickyEventRemove()
          utils.autocompleteEventRemove({$:$, elem:'#clinic_name_autocomplete'})
          utils.autocompleteEventRemove({$:$, elem:'#doctor_name_autocomplete'})
          utils.autocompleteEventRemove({$:$, elem:'#user_name_autocomplete'})
          utils.autocompleteEventRemove({$:$, elem:'#taking_period_autocomplete'})
          utils.autocompleteEventRemove({$:$, elem:'#deli_period_autocomplete'})
          next()
        }
      }
    }

    // 保存確認
    if (utils.isPresent(this)) {
      this.linkCallBack = function() {
        utils.stickyEventRemove()
        utils.autocompleteEventRemove({$:$, elem:'#clinic_name_autocomplete'})
        utils.autocompleteEventRemove({$:$, elem:'#doctor_name_autocomplete'})
        utils.autocompleteEventRemove({$:$, elem:'#user_name_autocomplete'})
        utils.autocompleteEventRemove({$:$, elem:'#taking_period_autocomplete'})
        utils.autocompleteEventRemove({$:$, elem:'#deli_period_autocomplete'})
        next()
      }
      this.onDiffConfirm('link', '')
    }
  },
  created () {
    this.linkCallBack = function(){}

    this.isSmartPhone = utils.isSmartPhone()
    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})

    // 施設
    if (this.$router.currentRoute.query.keep !== 'true') {
      if (this.$store.getters.canManage) {
        // 店舗ID
        this.shopId = this.$store.getters.currentShopId
      }
      this.patientId       = this.getQuerystringParams('patientId')
      this.reportId        = this.getQuerystringParams('reportId')
      this.facilityId      = this.getQuerystringParams('facilityId')
      this.type            = this.getQuerystringParams('type')
      this.patientName     = ''
      this.word50          = ''
      this.patientIndex    = 0
      this.reportHistNo    = 0
      this.phraseTypeId    = 1
      this.phraseSort      = 0
      this.phraseSaveIds   = ''
      this.phraseTargetElm = ''
      this.isHeaderOpen    = true
      this.search(false)
    } else {
      this.patientId       = this.getQuerystringParams('patientId')
      this.reportId        = this.getQuerystringParams('reportId')
      this.facilityId      = this.getQuerystringParams('facility_id')
      this.shopId          = this.$store.getters.reportEditSearchParams['shop_id']
      this.patientName     = this.$store.getters.patientSearchParams['patient_name']
      this.word50          = this.$store.getters.patientSearchParams['word50']
      this.patientIndex    = 0
      this.reportHistNo    = 0
      this.phraseTypeId    = 1
      this.phraseSort      = 0
      this.phraseSaveIds   = ''
      this.phraseTargetElm = ''
      this.isHeaderOpen    = true
      if (this.shopId === null) {
        if (this.$store.getters.canManage) {
          // 店舗ID
          this.shopId = this.$store.getters.currentShopId
        }
      }
      if (this.patient === null) {
        this.search(false)
      }
    }
    this.isTakingListShow = false // 配薬内容 処方日数
    this.isDeliListShow   = false // 今回配薬内容 処方日数

    // スティッキーイベント
    if (this.isSmartPhone) {
      utils.stickyEventSmartPhone({
        blockId:   'reportTop',
        targetId:  'smartPhone',
        addCls:    'report-smartphone-sticky',
      })
    } else {
      utils.stickyEventPc({
        blockId:   'reportTop',
        targetId:  'reportSticky',
        targetForm:'reportForm',
        addCls:    'report-pc-sticky',
        headerCls: 'navbar-fixed-top',
      })
    }

    // オートコンプリートイベント
    utils.autocompleteEvent({$:$, elem:'#clinic_name_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:this.getClinics, setSearchData:this.setSearchClinic, clear: this.clearClinics})
    utils.autocompleteEvent({$:$, elem:'#doctor_name_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:this.getDoctors, setSearchData:this.setSearchDoctor, clear: this.clearDoctors})
    utils.autocompleteEvent({$:$, elem:'#user_name_autocomplete',   search:() => {}, searchParams:false, searchAutocomplete:this.getUsers,   setSearchData:this.setSearchUser,   clear: this.clearUsers  })

    utils.autocompleteEvent({$:$, elem:'#taking_period_autocomplete', search:() => {}, searchParams:false, searchAutocomplete: () => {},   setSearchData:this.onSetPeriod})
    utils.autocompleteEvent({$:$, elem:'#deli_period_autocomplete'  , search:() => {}, searchParams:false, searchAutocomplete: () => {},   setSearchData:this.onSetPeriod})
  },
  mounted () {
    // ヘルプボタン表示
    utils.helpModalShow()
  },
  computed: {
    /*******************************************************
     * データ取得系
     ******************************************************/
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    /** 通知 */
    notify () {
      return this.$store.getters.reportEditNotify
    },
    /** システム管理者 または 薬剤師確認 */
    isAdminOrPharmacist() {
      return this.$store.getters.reportAdminOrPharmacist
    },
    /** 通知 報告書送信 */
    reportSendNotify () {
      return this.$store.getters.reportSendNotify
    },
    /** 患者データ */
    allReportEditData () {
      if (this.$store.getters.reportEditData !== null) {
        return this.$store.getters.reportEditData
      }
      return null
    },
    /** 患者データ */
    patient () {
      if (this.$store.getters.reportEditData !== null) {
        if (this.$store.getters.reportEditData.length - 1 < this.patientIndex) {
          return null
        }
        return this.$store.getters.reportEditData[this.patientIndex]['patient']['data']['attributes']
      }
      return null
    },
    /** 計画書データ */
    plan () {
      if (this.$store.getters.reportEditData !== null) {
        if (this.$store.getters.reportEditData.length - 1 < this.patientIndex) {
          return null
        }
        return this.$store.getters.reportEditData[this.patientIndex]['plan']
      }
      return null
    },
    /** 計画書データバックアップ */
    planBackup () {
      if (this.$store.getters.reportEditDataBackup !== null) {
        if (this.$store.getters.reportEditData.length - 1 < this.patientIndex) {
          return null
        }
        return this.$store.getters.reportEditDataBackup[this.patientIndex]['plan']
      }
      return null
    },
    /** 報告書データ */
    report () {
      if (this.$store.getters.reportEditData !== null) {
        if (this.$store.getters.reportEditData.length - 1 < this.patientIndex) {
          return null
        }
        return this.$store.getters.reportEditData[this.patientIndex]['report']
      }
      return null
    },
    /** 報告書データバックアップ */
    reportBackup () {
      if (this.$store.getters.reportEditDataBackup !== null) {
        return this.$store.getters.reportEditDataBackup[this.patientIndex]['report']
      }
      return null
    },
    /** 報告書履歴 */
    reportHist () {
      if (this.$store.getters.reportEditData) {
        var result = utils.getSafeArrVal(this.$store.getters.reportEditData[this.patientIndex], ['report_hist', 'data', 'attributes'], null)
        if (result === null) {
          return {}
        }
        result['taking-start-method-name'] = this.getMethodName(result['taking-start-method'])  // -/朝/昼/夕/就寝前
        result['taking-end-method-name']   = this.getMethodName(result['taking-end-method'])    // -/朝/昼/夕/就寝前
        result['deli-start-method-name']   = this.getMethodName(result['deli-start-method'])    // -/朝/昼/夕/就寝前
        result['deli-end-method-name']     = this.getMethodName(result['deli-end-method'])      // -/朝/昼/夕/就寝前
        result['taking-status-name']      = this.getFailureGood(result['taking-status'])        // 服薬状況 (不良/良)
        result['condition-change-name']   = this.getAriNashi(result['condition-change'])        // 体調変化 (無/有)
        result['remnant-status-name']     = this.getAriNashi(result['remnant-status'])          // 残薬状況 (無/有)
        result['interaction-name']        = this.getAriNashi(result['interaction'])             // 相互作用 (無/有)
        result['take-interaction-name']   = this.getAriNashi(result['take-interaction'])        // 服用薬と相互作用のある飲食物の摂取 (無/有)
        result['complication-name']       = this.getAriNashi(result['complication'])            // 他科受診、合併症 (無/有)
        result['other-dosage-name']       = this.getAriNashi(result['other-dosage'])            // 他科からの投薬 (無/有)
        result['otc-combination-name']    = this.getAriNashi(result['otc-combination'])         // ＯＴＣの併用 (無/有)
        result['last-request-name']       = this.getAriNashi(result['last-request'])            // 後発品の希望 (無/有)
        result['visit-duty-name']         = this.getAriNashi(result['visit-duty'])              // 義務照会 (無/有)
        result['dispense-idea-name']      = this.getAriNashi(result['dispense-idea'])           // 調剤上の工夫 (無/有)
        result['side-effect-status-name'] = this.getAriNashi(result['side-effect-status'])      // 副作用発見(無/有)
        result['medicine-notebook-name']  = this.getAriNashi(result['medicine-notebook'])       // 薬手帳(無/有)

        return result
      }
      return {}
    },
    /** 報告書データありなし */
    reportDataExists () {
      return this.$store.getters.reportEditDataExists
    },
    /** 施設データ */
    facility () {
      if (this.$store.getters.reportEditData !== null) {
        return this.$store.getters.reportEditData[this.patientIndex]['facility']['data']['attributes']
      }
      return null
    },
    /** 医療機関データ */
    careOffices () {
      return this.$store.getters.careOffices
    },
    /** クリニック */
    clinics () {
      return this.$store.getters.clinicsAutocomplete
    },
    /** クリニック再検索用 */
    clinicsSearch () {
      return this.$store.getters.clinics
    },
    /** 医師 */
    doctors () {
      return this.$store.getters.doctorsAutocomplete
    },
    /** 報告者 */
    users () {
      return this.$store.getters.usersAutocomplete
    },
    /** 定形 */
    phrases () {
      if (this.$store.getters.reportEditPhrases) {
        return this.$store.getters.reportEditPhrases
      }
      return null
    },
    /** 定形明細 */
    phrasesDetail () {
      if (this.$store.getters.reportEditPhrases) {
        var phrases = this.$store.getters.reportEditPhrases
        var data = null
        for (var i = 0; i < phrases.length; i++) {
          if (phrases[i]['phrase_type_id'] === this.phraseTypeId) {
            data = phrases[i].phrase
            break
          }
        }
        // 見つからない場合は先頭
        if (data === null && phrases.length > 0) {
          data = phrases[0].phrase
          this.phraseTypeId = data['phrase_type_id']
        }
        if (data !== null) {
          if (utils.str2int(this.phraseSort)  === 0) {
            data = utils.objArraySort(data, "using_count", "desc")
          }
          else {
            data = utils.objArraySort(data, "phrase", "asc")
          }
          return data
        }
      }
      return null
    },
    /** 件数 */
    totalCount () {
      return this.$store.getters.reportEditTotalCount
    },
    /** セレクトボックス 報告書種類 */
    getSelectReportType () {
      return this.$store.getters.reportEditSelectReportType
    },

    /*******************************************************
     * 確認・状態確認系
     ******************************************************/
    /**
     * 必須チェック
     * @return false:OK true:NG
     **/
    required () {
      return this.requiredCheck(this.report)
    },

    /** 必須チェック、和暦チェック */
    isRequiredComplete () {
      var req  = this.required
      var result = true
      // 必須
      for (var key in req) {
        if (req[key]) {
          result = false
          break
        }
      }
      return result
    },
    /** ヘッダー部の保存ボタン制御 */
    isAllSaveDisabled () {
      if (this.$store.getters.reportEditData === null || this.$store.getters.reportEditData.length <= 0) {
        return false // ng
      }

      var editData = this.$store.getters.reportEditData
      var result = true // 保存ボタン 利用可

      // １つでも一時保存があれば押下可能
      if (result) {
        var isExists = false
        for (var i = 0; i < editData.length; i++) {
          var report = editData[i]['report']
          if (report['post_status'] === constant.report.post_status.temp) {
            isExists = true
            break
          }
        }
        if (!isExists) {
          result = false // 保存ボタン 利用不可
        }
      }

      return result
    },

    /** 印刷必須和暦チェック */
    requiredPrint () {
      return {
        printDeliveryDate:        !this.printDeliveryDate,
        printDeliveryDate_format: !utils.isWareki(this._self.$t, this.printDeliveryDate),
      }
    },

    /** 日付一括必須チェック */
    requiredBulk () {
      return {
        bulkDate:        !this.bulkDate,
        bulkDate_format: !utils.isWareki(this._self.$t, this.bulkDate),
      }
    },
    /** 必須チェック、和暦チェック */
    isBulkComplete () {
      var req  = this.requiredBulk
      var result = true
      // 必須
      for (var key in req) {
        if (req[key]) {
          result = false
          break
        }
      }
      return result
    },

    /** 送信可能状態 */
    isSendPostOk () {
      if (this.$store.getters.reportEditData === null || this.$store.getters.reportEditData.length <= 0) {
        return false // ng
      }

      // システム管理者 または 薬剤師確認
      if (!this.isAdminOrPharmacist) {
        return false // ng
      }

      var editData = this.$store.getters.reportEditData
      var isExists = false
      for (var i = 0; i < editData.length; i++) {
        var report = editData[i]['report']
        if (report['post_status'] === constant.report.post_status.no_post && !report['edit_mode']) {
          isExists = true
          break
        }
      }
      return isExists
    },
    /** 送信済み状態を確認 */
    isPostStatusPost: function() {
      if (this.report === null) {
        return false
      }
      // 送信完了
      if (this.report['post_status'] === constant.report.post_status.post) {
        return true
      }
      return false
    },
    /** 編集を制御 */
    isEdit () {
      if (this.report === null) {
        return false
      }
      // 送信完了
      if (this.report['post_status'] === constant.report.post_status.temp) {
        return true
      }
      // 未送信
      if (this.report['post_status'] === constant.report.post_status.no_post) {
        // 編集モード
        if (this.report['edit_mode']) {
          return true
        }
      }
      // 送信済み
      if (this.report['post_status'] === constant.report.post_status.post) {
        return true
      }
      return false
    },
    /** 編集ボタン制御を制御 */
    isEditBtn () {
      if (this.report === null) {
        return false
      }
      // 未送信
      if (this.report['post_status'] === constant.report.post_status.no_post) {
        // 編集モード
        if (!this.report['edit_mode']) {
          return true // 編集ボタン表示
        }
      }
      return false
    },
    isRequireSendClinic() {
      if (this.report === null) {
        return true
      }
      if (this.report['report_type'] === constant.report.report_type.kyotaku || this.report['report_type'] === constant.report.report_type.yakuzai_kanri) {
        return true
      }
      return false
    },
    isRequireSendCareoffice() {
      if (this.report === null) {
        return true
      }
      if (this.report['report_type'] === constant.report.report_type.kyotaku) {
        return true
      }
      return false
    },
    /** 前の患者ボタン制御 */
    isPatientPrev () {
      if (this.patientIndex > 0) {
        return true
      }
      return false
    },
    /** 次の患者ボタン制御 */
    isPatientNext () {
      if (this.$store.getters.reportEditData !== null) {
        if (this.$store.getters.reportEditData.length - 1 > this.patientIndex) {
          return true
        }
      }
      return false
    },
    /** 報告書 次回ボタン制御 */
    isReportHistPrev () {
      if (this.$store.getters.reportEditData !== null) {
        var report_hist_count = this.$store.getters.reportEditData[this.patientIndex]['report_hist_count']
        var report_hist_no = this.$store.getters.reportEditData[this.patientIndex]['report_hist_no']
        if (report_hist_count > 0 && report_hist_no > 0) {
          return true
        }
      }
      return false
    },
    /** 報告書 前回ボタン制御 */
    isReportHistNext () {
      if (this.$store.getters.reportEditData !== null) {
        var report_hist_count = this.$store.getters.reportEditData[this.patientIndex]['report_hist_count']
        var report_hist_no = this.$store.getters.reportEditData[this.patientIndex]['report_hist_no']
        if (report_hist_count > 0 && report_hist_count - 1 > report_hist_no) {
          return true
        }
      }
      return false
    },
    /** 報告書種類が 医師に提出 対象確認 */
    isReportTypeClinic () {
      return this.isReportTypeClinicCheck(this.report, false)
    },
    /** 報告書種類が ケアマネに提出 管理対象確認 */
    isReportTypeCareoffice () {
      return this.isReportTypeCareofficeCheck(this.report, false)
    },
    /** 履歴 報告書種類が 医師に提出 対象確認 */
    isHistReportTypeClinic () {
      return this.isReportTypeClinicCheck(this.reportHist, true)
    },
    /** 履歴 報告書種類が ケアマネに提出 管理対象確認 */
    isHistReportTypeCareoffice () {
      return this.isReportTypeCareofficeCheck(this.reportHist, true)
    },
    /** 補助入力制御 */
    isAutoConsultPoints () {
      if (this.$store.getters.reportEditData === null || this.$store.getters.reportEditData.length <= 0) {
        return false // ng
      }
      var editData = this.$store.getters.reportEditData
      var isOk = false
      for (var i = 0; i < editData.length; i++) {
        var report = editData[i]['report']
        if (
          report['post_status'] === constant.report.post_status.temp ||                          // 一時保存
          (report['post_status'] === constant.report.post_status.no_post && report['edit_mode']) // 未送信かつ編集モード
        ) {
          isOk = true
          break
        }
      }
      return isOk
    },

    /** 報告書参照 ＞ 報告書詳細からの遷移 */
    isReportDetail () {
      if (this.patientId !== null && this.reportId !== null) {
        return true
      }
      return false
    },

    /** 報告書送信履歴 ＞ 報告書詳細からの遷移 */
    isReportSend () {
      return utils.isPresent(this.type)
    },

    /** 表示中の色取得 */
    getDispColor () {
      var color = [
        'label-success',
        'label-info',
        'label-warning',
        'label-danger',
        'label-primary',
        'label-default'
      ]
      if (this.$store.getters.reportEditData === null) {
        return color[0]
      }
      if (this.$store.getters.reportEditData.length - 1 < this.patientIndex) {
        return color[0]
      }
      var editData = this.$store.getters.reportEditData
      var id = utils.str2int(editData[this.patientIndex]['patient']['data']['id'])
      var count = 0
      for (var i = 0; i < editData.length; i++) {
        if (id === utils.str2int(editData[i]['patient']['data']['id'])) {
          if (this.patientIndex === i) {
            break
          }
          count++
        }
      }
      return color[count % (color.length)]
    },

    /** apiローディング */
    loading () {
      return this.$store.getters.apiLoading
    }
  },

  methods: {
    /** スクロール */
    backToTop: function () {
      window.scrollTo(0, 0)
    },
    /*******************************************************
     * リンク系
     ******************************************************/
    /** ホーム */
    goHome: function() {
      this.$router.push({ path: '/'})
    },
    /** 施設検索 */
    goFacility: function() {
      this.$router.push({ path: '/facilities?type=create_report', query: {'keep': 'true'}})
    },
    /** 患者検索 */
    goPatient: function() {
      this.$router.push({ path: '/patients/' + this.getQuerystringParams('facilityId') + '/select/?type=create_report', query: {'keep': 'true'}})
    },
    /** 計画書参照 */
    goPalnDetail: function() {
      var url = location.href
      var div = this.$router.currentRoute.path
      var path = url.substring(0, url.indexOf(div) + 1) + 'plans/detail'
      path += '/'+ this.getQuerystringParams('facilityId')
      path += '/'+ this.report.patient_id
      path += '/'+ this.plan.plan_id
      path += '/view'
      window.open(path, 'plan_detail')
    },
    /** 施設詳細 */
    goFacilityDetail: function(id, facility_type) {
      var action = 'facilities'
      // 個人宅
      if (constant.facility.facility_type.person === facility_type) {
        action = 'facility_persons'
      }
      var url = location.href
      var div = this.$router.currentRoute.path
      var path = url.substring(0, url.indexOf(div) + 1)
      path += action
      path += '/detail'
      path += '/'+ id
      path += '?'+ 'type=select_facility'
      path += '&'+ 'view=true'
      window.open(path, 'facilities_detail')
    },
    /** 患者検索 */
    goPatientsList: function () {
      this.$router.push({ path: '/patients/list/', query: {'keep': 'true'}})
    },
    /** 報告書検索 */
    goPatientsReport: function () {
      this.$router.push({ path: '/patients/report/' + this.facilityId + '/' + this.patientId, query: {'keep': 'true'}})
    },
    /** 報告書詳細 */
    goReportDetail: function () {
      if (this.isReportSend) {
        this.$router.push({ path: '/reports/send/detail/' + this.type + '/' + this.facilityId + '/' + this.patientId + '/' + this.reportId, query: {type: this.$router.currentRoute.query.type}})
      } else {
        this.$router.push({ path: '/reports/detail/' + this.facilityId + '/' + this.patientId + '/' + this.reportId })
      }
    },
    /** 施設検索等 */
    goReportHistoryList: function () {
      if (this.type === 'facility') {
        this.$router.push({path: '/facilities', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.type === 'facility_person') {
        this.$router.push({path: '/facility_persons', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.type === 'clinic') {
        this.$router.push({path: '/clinics', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.type === 'care_office') {
        this.$router.push({path: '/care_offices', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      }
    },
    /** 送信履歴 */
    goReportHistory:function () {
      this.$router.push({ path: '/reports/history/' + this.type + '/' + this.facilityId, query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
    },
    /*******************************************************
     * 検索系
     ******************************************************/
    /** 患者検索 */
    search: function (readMore, option) {
      // オートコンプリートクリア
      this.autocompleteAllClear()

      var url = null
      var clear = true
      var opt = Object.assign({}, {'patient_name': null, 'patient_id': null}, option)
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      this.searchCallbackFlag = false

      this.patientIndex = 0   // 患者インデックスクリア
      this.reportHistNo = 0   // 履歴番号クリア
      this.phraseSaveIds = '' // 定型文IDクリア
      var data = {
        'type':         'report',
        'facility_id':  this.facilityId,
        'shop_id':      this.shopId,
        'word50':       this.word50,
        'patient_name': this.patientName,
        'patient_id':   opt.patient_id,
        'user_id':      this.$store.getters.userId
      }
      if (this.reportId !== null && this.patientId !== null) {
        // 詳細画面からの遷移
        data['patient_id'] = this.patientId
        data['report_id']  = this.reportId
      }
      this.$store.dispatch('REPORT_EDIT_SEARCH', {url: url, clear: clear, data: data, callback: callback})
    },

    /** 前の患者 */
    patientPrev: function() {
      if (this.$store.getters.reportEditData === null || this.$store.getters.reportEditData.length <= 0) {
        return
      }
      if (this.patientIndex > 0) {
        // オートコンプリートクリア
        this.autocompleteAllClear()
        // 前の患者
        this.patientIndex -= 1
      }
    },
    /** 次の患者 */
    patientNext: function() {
      if (this.$store.getters.reportEditData === null || this.$store.getters.reportEditData.length <= 0) {
        return
      }
      if (this.$store.getters.reportEditData.length - 1 > this.patientIndex) {
        // オートコンプリートクリア
        this.autocompleteAllClear()
        // 次の患者
        this.patientIndex += 1
      }
    },

    /** 医療機関 */
    getClinics: function () {
      var name = this.report['ac_clinic_name']
      if (name === this.$t('none_list.name')) {
        name = ''
      }
      this.$store.dispatch('CLINIC_SEARCH', {
        data: {
          'shop_id': this.shopId,
          'clinic_name': name,
          'all_get': true,
        },
        loadparams: false,
        autocomplete: true,
        noneList: {id: this.$t('none_list.id'), name: this.$t('none_list.name')}
      })
    },
    clearClinics: function () {
      if (this.report['ac_clinic_name'] !== this.report['clinic_name']) {
        this.report['ac_clinic_name'] = this.report['clinic_name']
        this.$store.dispatch('REPORT_EDIT_MSG_ALERT', { message: this.$t('messages.select_list_item'), danger: true })
      }
      // オートコンプリートクリア
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR')
    },
    setSearchClinic: function (id, name) {
      if (this.report['clinic_id'] !== id) {
        // IDが変更されて場合 医師をクリア
        this.report['doctor_id'] = ''
        this.report['doctor_name'] = ''
        this.report['ac_doctor_name'] = ''
        // 送信内容を変更
        for (var i = 0; i < this.clinics.length; i++) {
          if (utils.str2int(this.clinics[i].id) === utils.str2int(id)) {
            var prevFax                                         = this.report['clinic_send_info']['fax']
            var prevMail                                        = this.report['clinic_send_info']['email']
            this.report['clinic_send_info']['send_type']        = this.clinics[i].attributes['send-type']
            this.report['clinic_send_info']['send_type_post']   = this.clinics[i].attributes['send-type-post']
            this.report['clinic_send_info']['send_type_fax']    = this.clinics[i].attributes['send-type-fax']
            this.report['clinic_send_info']['send_type_email']  = this.clinics[i].attributes['send-type-email']
            this.report['clinic_send_info']['send_timing']      = this.clinics[i].attributes['send-timing']
            this.report['clinic_send_info']['send_timing_hour'] = this.clinics[i].attributes['send-timing-hour']
            this.report['clinic_send_info']['fax']              = this.clinics[i].attributes['fax']
            this.report['clinic_send_info']['email']            = this.clinics[i].attributes['email']
            this.report['clinic_send_info']['fusezi_flag']      = this.clinics[i].attributes['fusezi-flag']

            var checkOff = true
            if (this.report['clinic_send_check'] === true || utils.str2int(this.report['clinic_send_check']) === constant.report.send_check) {
              checkOff = false
            }
            if (checkOff) {
              // チェックが付与されていなかったら書換
              this.report['clinic_send_type']        = this.clinics[i].attributes['send-type']
              this.report['clinic_send_type_post']   = this.clinics[i].attributes['send-type-post']
              this.report['clinic_send_type_fax']    = this.clinics[i].attributes['send-type-fax']
              this.report['clinic_send_type_email']  = this.clinics[i].attributes['send-type-email']
              this.report['clinic_send_timing']      = this.clinics[i].attributes['send-timing']
              this.report['clinic_send_timing_hour'] = this.clinics[i].attributes['send-timing-hour']
              this.report['clinic_fax']              = this.clinics[i].attributes['fax']
              this.report['clinic_email']            = this.clinics[i].attributes['email']
              this.report['clinic_fusezi_flag']      = this.clinics[i].attributes['fusezi-flag']
            }
            else {
              // 送付方法-FAXがデフォルトのままであれば、書換
              if (this.report['clinic_fax'] == prevFax) {
                this.report['clinic_fax'] = this.clinics[i].attributes['fax']
              }
              // 送付方法-emailがデフォルトのままであれば、書換
              if (this.report['clinic_email'] == prevMail) {
                this.report['clinic_email'] = this.clinics[i].attributes['email']
              }
            }
            break
          }
        }
      }
      this.report['clinic_id'] = id
      this.report['clinic_name'] = name
      this.report['ac_clinic_name'] = name
      // オートコンプリートクリア
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR')
      this.getClinicSendInfo(this.report, this.patientIndex)
    },

    /** 医師 */
    getDoctors: function () {
      var name = this.report['ac_doctor_name']
      if (name === this.$t('none_list.name')) {
        name = ''
      }
      this.$store.dispatch('DOCTOR_SEARCH', {
        data: {
          'shop_id': this.shopId,
          'clinic_id': this.report['clinic_id'],
          'doctor_name': name,
          'all_get': true,
        },
        loadparams: false,
        autocomplete: true,
        noneList: {id: this.$t('none_list.id'), name: this.$t('none_list.name')}
      })
    },
    clearDoctors: function () {
      if (this.report['ac_doctor_name'] !== this.report['doctor_name']) {
        this.report['ac_doctor_name'] = this.report['doctor_name']
        this.$store.dispatch('REPORT_EDIT_MSG_ALERT', { message: this.$t('messages.select_list_item'), danger: true })
      }
      // オートコンプリートクリア
      this.$store.dispatch('DOCTOR_AUTOCOMPLETE_CLEAR')
    },
    setSearchDoctor: function (id, name) {
      if (this.report['clinic_id'] !== id) {
        // IDが変更されて場合
        // 送信内容を変更
        var exists = false
        for (var i = 0; i < this.doctors.length; i++) {
          if (utils.str2int(this.doctors[i].id) === utils.str2int(id)) {
            if (utils.isPresent(this.doctors[i].attributes['email'])) {
              this.report['clinic_email'] = this.doctors[i].attributes['email']
              exists = true
            }
            break
          }
        }
        // 存在しなかった場合は医療期間を設定
        if (!exists) {
          if (utils.isPresent(this.report['clinic_id'])) {
            var self = this
            var callback = function () {
              if (self.clinicsSearch.length > 0) {
                self.report['clinic_email'] = self.clinicsSearch[0].attributes['email']
              }
            }
            this.$store.dispatch('CLINIC_SEARCH', {
              data: {'shop_id': this.shopId, 'clinic_id': this.report['clinic_id']},
              loadparams: false,
              autocomplete: false,
              callback: callback
            })
          }
        }
      }

      this.report['doctor_id'] = id
      this.report['doctor_name'] = name
      this.report['ac_doctor_name'] = name
      // オートコンプリートクリア
      this.$store.dispatch('DOCTOR_AUTOCOMPLETE_CLEAR')
      this.getClinicSendInfo(this.report, this.patientIndex)
    },

    /** 申請者 */
    getUsers: function () {
      var name = this.report['ac_user_name']
      if (name === this.$t('none_list.name')) {
        name = ''
      }
      // 管理者 薬剤師のみ選択可能
      this.$store.dispatch('USER_SEARCH', {
        data: {
          'shop_id': this.shopId,
          'user_authority_or_pharmacist_flag': 1,
          'user_name': name,
          'all_get': true,
        },
        loadparams: false,
        autocomplete: true,
        noneList: {id: this.$t('none_list.id'), name: this.$t('none_list.name')}
      })
    },
    clearUsers: function () {
      if (this.report['ac_user_name'] !== this.report['user_name']) {
        this.report['ac_user_name'] = this.report['user_name']
        this.$store.dispatch('REPORT_EDIT_MSG_ALERT', { message: this.$t('messages.select_list_item'), danger: true })
      }
      // オートコンプリートクリア
      this.$store.dispatch('USER_AUTOCOMPLETE_CLEAR')
    },
    setSearchUser: function (id, name) {
      this.report['reportor_id'] = id
      this.report['user_name'] = name
      this.report['ac_user_name'] = name
      // オートコンプリートクリア
      this.$store.dispatch('USER_AUTOCOMPLETE_CLEAR')
    },

    /*******************************************************
     * イベント系
     ******************************************************/
    /** 変更確認モーダル */
    onDiffConfirm: function(name, param) {
      if (this.$store.getters.reportEditData === null || this.$store.getters.reportEditDataBackup === null) {
        this.doCall(name, param)
        return
      }
      // 差分確認
      var diffFlg = false
      for (var i = 0; i < this.$store.getters.reportEditData.length; i++) {
        var a = this.$store.getters.reportEditData[i]
        var b = this.$store.getters.reportEditDataBackup[i]
        var isPlanDiff = utils.checkObjDiff(a['plan'], b['plan'])
        var isReportDiff = utils.checkObjDiff(a['report'], b['report'])
        if (isPlanDiff || isReportDiff) {
          diffFlg = true
          break
        }
      }
      if (diffFlg) {
        // 変更あり モーダル表示
        var confirm_modal_button = document.getElementById('confirm_modal_button')
        var modal = document.getElementById('confirm_modal')
        modal.setAttribute('data-name', name)
        modal.setAttribute('data-param', param)
        confirm_modal_button.click() // 保存確認モーダル表示 イベント発火
      } else {
        this.doCall(name, param)
      }
    },
    /** 保存確認モーダル 保存しない 検索または遷移 */
    onConfirmNoSave: function() {
      // オートコンプリートクリア
      this.autocompleteAllClear()

      var modal = document.getElementById('confirm_modal')
      var name = modal.getAttribute('data-name')
      var param = modal.getAttribute('data-param')
      if (param === 'true') {
        param = true
      } else if (param === 'false') {
        param = false
      }
      setTimeout(() => {
        this.doCall(name, param)
      }, 500)
    },
    /** 各メソッド実行 */
    doCall: function(name, param) {
      // オートコンプリートクリア
      this.autocompleteAllClear()

      switch (name) {
        case 'search_word50':
          // 50音
          this.word50 = param
          this.search(false)
          break
        case 'search':
          // 検索
          this.search(param)
          break
        case 'link':
          if (utils.isPresent(this.linkCallBack())) {
            this.linkCallBack() // callbackで beforeRouteLeave の next() メソッド実行
          }
          break
        default:
          break
      }
    },

    /** 編集モード */
    onEditMode: function() {
      this.report['edit_mode'] = true
    },

    /** 報告書追加作成 */
    onAddNewReport: function() {
      var editData = this.$store.getters.reportEditData
      var patient_id = utils.str2int(editData[this.patientIndex]['patient']['data']['id'])
      var otherNo = 1
      for (var i = 0; i < editData.length; i++) {
        if (patient_id === utils.str2int(editData[i]['patient']['data']['id'])) {
          if (this.patientIndex === i) {
            break
          }
          otherNo++
        }
      }

      this.$store.dispatch('REPORT_EDIT_ADD_NEW_REPORT', {
        patientIndex: this.patientIndex,
        reportHistNo: this.reportHistNo,
        otherNo: otherNo,
        callback: this.addNewReportCallback,
        data: {
          patient_id: patient_id
        }
      })
    },
    /** 報告書追加作成コールバック */
    addNewReportCallback: function() {
      this.patientNext()
    },

    /** 削除ボタン */
    onClickDeleteReport: function () {
      var patientIndex = this.patientIndex
      var editData = this.$store.getters.reportEditData[patientIndex]
      var patient_id = editData['patient_id']

      // 同じ患者が存在するか確認
      var editDataList = this.$store.getters.reportEditData
      var patientIdCount = 0
      for (var i = 0; i < editDataList.length; i++) {
        var id = utils.str2int(editDataList[i]['report']['patient_id'])
        if (utils.str2int(patient_id) === id) {
          patientIdCount++
        }
      }
      // 削除報告書の患者が1件なら選択解除
      if (patientIdCount <= 1) {
        var data = {
          type:       'patient',
          sel_flag:   0,
          patient_id: patient_id
        }
        this.$store.dispatch('PATIENT_SET_SEL_FLAG', {data: data, callback: () => {}})
      }

      // 削除
      if (utils.isBlank(this.report['report_id'])) {
        // 追加が保存されていない場合
        this.$store.dispatch('REPORT_EDIT_REPORT_DELETE_NEW_REPORT',{patientIndex: patientIndex, callback: this.onDeleteReportCallback})
      } else {
        // 追加が保存されている場合
        var self = this
        var callback = function () {
          self.$store.dispatch('REPORT_EDIT_REPORT_DELETE_NEW_REPORT',{patientIndex: patientIndex, callback: self.onDeleteReportCallback})
        }
        this.$store.dispatch('REPORT_DELETE',{
          reportId:    this.report['report_id'],
          data:        {
            'patient_id': patient_id
          },
          callback:    callback,
          loadparams: 'block'
        })
      }
    },
    onDeleteReportCallback: function (moveFlg) {
      if (moveFlg) {
        if (this.isReportDetail) {
          this.goReportDetail() // 詳細
        } else {
          this.goPatient() // 患者検索
        }
      } else {
        if (this.patientIndex <= 0) {
          this.patientIndex = 0
        } else {
          this.patientIndex -= 1
        }
      }
    },

    /** 報告書 保存 */
    onClickSaveReport: function(opt) {
      var editData = this.$store.getters.reportEditData[this.patientIndex]
      var patient_id = editData['patient_id']
      var request = []
      request.push({
        plan:   this.plan,
        report: this.report,
      })

      var data = {
        'type':             opt['type'],
        'post_status':      opt['post_status'],
        'update_resend':    opt['update_resend'],
        'rows':             request,
        'facility_id':      this.facilityId,
        'shop_id':          this.shopId,
        'word50':           this.word50,
        'patient_name':     this.patientName,
        // 'phrase_ids':       this.phraseSaveIds,
        'send_timing_hour': this.sokujiSendTimingHour,
      }
      if (this.reportId !== null && this.patientId !== null) {
        // 詳細画面からの遷移
        data['patient_id'] = this.patientId
        data['report_id']  = this.reportId
      } else {
        data['report_from_make_mode'] = true // 報告書作成
      }
      this.$store.dispatch('REPORT_EDIT_SAVE', {data: data, callback: this.saveReportCallback, patient_index: this.patientIndex})
    },
    /** 報告書 全て保存 */
    onClickAllSaveReport: function(opt) {
      var editData = this.$store.getters.reportEditData
      var request = []
      for (var i = 0; i < editData.length; i++) {
        request.push({
          plan:   editData[i]['plan'],
          report: editData[i]['report'],
        })
      }

      // 送信時、同じ患者が複数いる場合、選択状態を解除するかを取得
      var selFlagArr = []
      if (opt['post_status'] === constant.report.post_status.post) {
        for (var i = 0; i < editData.length; i++) {
          var id = utils.str2int(editData[i]['report']['patient_id'])
          if (selFlagArr.length <= 0) {
            selFlagArr.push({patient_id: id, sel_flag: 0}) // 未選択状態
          } else {
            // 同じ患者IDが無いか確認
            var exists = false
            for (var flagCnt = 0; flagCnt < selFlagArr.length; flagCnt++) {
              if (id === utils.str2int(selFlagArr[flagCnt].patient_id)) {
                exists = true // 既に配列に存在する
                break
              }
            }
            // 存在しない場合
            if (!exists) {
              selFlagArr.push({patient_id: id, sel_flag: 0}) // 未選択状態
            }
          }
        }
        for (var i = 0; i < editData.length; i++) {
          var report = editData[i]['report']
          // 一時保存状態の場合は選択を解除しない
          if (report['post_status'] === constant.report.post_status.temp) {
            for (var j = 0; j < selFlagArr.length; j++) {
              if (utils.str2int(report['patient_id']) === selFlagArr[j].patient_id) {
                selFlagArr[j].sel_flag = 1 // 選択状態
              }
            }
          }
        }
      }

      var data = {
        'type':             opt['type'],
        'post_status':      opt['post_status'],
        'update_resend':    opt['update_resend'],
        'rows':             request,
        'user_id':          this.$store.getters.userId,
        'facility_id':      this.facilityId,
        'shop_id':          this.shopId,
        'word50':           this.word50,
        'patient_name':     this.patientName,
        // 'phrase_ids':       this.phraseSaveIds,
        'send_timing_hour': this.sokujiSendTimingHour,
        'patient_sel_flags': selFlagArr,
      }
      if (this.reportId !== null && this.patientId !== null) {
        // 詳細画面からの遷移
        data['patient_id'] = this.patientId
        data['report_id']  = this.reportId
      } else {
        data['report_from_make_mode'] = true // 報告書作成
      }
      this.$store.dispatch('REPORT_EDIT_ALL_SAVE', {data: data, callback: this.saveReportCallback, patient_index: this.patientIndex})
    },
    /** 報告書 保存コールバック */
    saveReportCallback: function(isPatientIndexChange, patientIndex) {
      if (isPatientIndexChange) {
        // 提出により患者数が減った場合
        this.patientIndex = patientIndex
      } else {
        this.phraseSaveIds = '' // 定型文IDクリア
        // 全てが未選択の場合は前画面に遷移
        if (this.$store.getters.reportEditTotalCount <= 0) {
          if (this.isReportDetail) {
            this.goReportDetail() // 詳細
          } else {
            this.goPatient() // 患者検索
          }
        }
      }
    },
    /** 即時送信 モーダル表示 */
    onSokujiModalShow: function (timer) {
      this.sokujiSendTimingHour = constant.report.send_timing_hour_default
      var button = document.getElementById('confirm_sokuji_modal_button')
      setTimeout(() => {
        button.click() // モーダル表示 イベント発火
      }, timer)
    },
    /** 報告書履歴 次回 */
    onReportHistPrev: function() {
      // オートコンプリートクリア
      this.autocompleteAllClear()

      var editData = this.$store.getters.reportEditData[this.patientIndex]
      var report_hist_no = editData['report_hist_no']
      var patient_id     = editData['patient_id']
      var last_report_id = editData['last_report_id']
      this.$store.dispatch('REPORT_EDIT_SEARCH_HIST', {
        data: {
          'facility_id':    this.facilityId,
          'shop_id':        this.shopId,
          'patient_index':  this.patientIndex,
          'patient_id':     patient_id,
          'report_hist_no': report_hist_no - 1,
          'last_report_id': last_report_id,
        }
      })
    },
    /** 報告書履歴 前回 */
    onReportHistNext: function() {
      // オートコンプリートクリア
      this.autocompleteAllClear()

      var editData = this.$store.getters.reportEditData[this.patientIndex]
      var report_hist_no = editData['report_hist_no']
      var patient_id     = editData['patient_id']
      var last_report_id = editData['last_report_id']
      this.$store.dispatch('REPORT_EDIT_SEARCH_HIST', {
        data: {
          'facility_id':    this.facilityId,
          'shop_id':        this.shopId,
          'patient_index':  this.patientIndex,
          'patient_id':     patient_id,
          'report_hist_no': report_hist_no + 1,
          'last_report_id': last_report_id,
        },
        loadparams: 'block',
      })
    },

    /** 報告書印刷モーダル */
    onPrintModalShow: function() {
      this.printDeliveryDate = utils.sereki2Wareki(this.$t, new Date())
      var button = document.getElementById('print_modal_button')
      button.click() // モーダル表示 イベント発火
    },
    /** 報告書印刷 */
    onPrint: function(type) {
      // 非表示項目
      var row_hidden = []
      if (!this.isCheckRoomNo) {
        row_hidden.push(constant.report.xls.roomno_nashi) // 部屋番号なし
      } else {
        row_hidden.push(constant.report.xls.roomno_ari) // 部屋番号あり
      }
      if (!this.isCheckHaiyaku) {
        row_hidden.push(constant.report.xls.haiyaku1) // 配薬
        row_hidden.push(constant.report.xls.haiyaku2) // 今回配薬
      }
      if (!this.isCheckHenkou) {
        row_hidden.push(constant.report.xls.henkou) // 変更点
      }
      if (!this.isCheckShidou) {
        row_hidden.push(constant.report.xls.shidou) // 指導
      }
      if (!this.isCheckKakunin) {
        row_hidden.push(constant.report.xls.kakunin) // 確認事項
        row_hidden.push(constant.report.xls.kakunin2) // 確認事項2行目
      }
      row_hidden = row_hidden.join(',')

      // 新規ウィンドウ
      var win = null
      if (type === 'print') {
        var win = window.open(constant.html.loading)
      }
      var data = {
        'facility_id':   this.facilityId,
        'shop_id':       this.shopId,
        'delivery_date': this.printDeliveryDate,
        'row_hidden':    row_hidden,
        'type':          type,
      }
      if (this.reportId !== null && this.patientId !== null) {
        // 詳細画面からの遷移
        data['patient_id'] = this.patientId
        data['report_id']  = this.reportId
      }
      this.$store.dispatch('REPORT_EDIT_PRINT', {data: data, callback:this.onPrintCallback, win:win})
    },
    /** 報告書印刷 */
    onPrintCallback: function(data, win) {
      // 失敗
      if (utils.isPresent(data.error)) {
        if (win !== null) {
          var msg = this.$t('messages.print.not_found')
          if (data.error === 'not_found') {
            msg = this.$t('messages.print.not_found')
          }
          win.location.href = constant.html.error + encodeURIComponent(msg)
        }
        return
      }
      // 成功
      var link = null
      if (data.type === 'print') {
        if (win !== null) {
          win.location.href = data.download
        }
      } else {
        link = document.getElementById('print_download_link')
        link.setAttribute('download', data.download)
        link.href = data.download
        link.click()
      }
      // 後始末
      setTimeout(() => {
        this.$store.dispatch('REPORT_EDIT_PRINT_DEL', {data: {delete_path: data.delete_path}})
      }, constant.print_delete_time)
    },

    /** 処方日 = 調剤日 */
    onPrescribeDateChange: function () {
      if (utils.isBlank(this.report['prescribe_date'])) {
        this.report['make_date'] = ''
      }
      if (utils.isWareki(this.report['prescribe_date'])) {
        this.report['make_date'] = this.report['prescribe_date']
      }
      this.getClinicSendInfo(this.report, this.patientIndex)
    },
    /** 訪問日変更 */
    onChangeDeliveryDate: function () {
      this.getCareofficeSendInfo(this.report, this.patientIndex)
    },
    /** 報告書種類変更 */
    onChangeReportType: function () {
      this.setRequiredSend()
      this.getCareofficeSendInfo(this.report, this.patientIndex)
      this.getClinicSendInfo(this.report, this.patientIndex)
    },
    setRequiredSend: function () {
      this.report['require_clinic_send'] = 0
      this.report['require_careoffice_send'] = 0

      if (this.report['report_type'] == constant.report.report_type.kyotaku) {
        this.report['require_clinic_send'] = 1
        this.report['require_careoffice_send'] = 1
      } else if (this.report['report_type'] == constant.report.report_type.yakuzai_kanri) {
        this.report['require_clinic_send'] = 1
      }
    },
    /** 報告書種類変更 */
    getCareofficeSendInfo: function (report, patientIndex) {
      // 報告書種類が ケアマネに提出 管理対象確認
      if (this.isReportTypeCareofficeCheck(report)) {
        var data = {
          patient_index: patientIndex,
          patient_id:    report['patient_id'],
          delivery_date: utils.wareki2Seireki(this.$t, report['delivery_date'], 'y-m-d') ,
        }
        var self = this
        var callback = function (data) {
          var report = self.$store.getters.reportEditData[data['patient_index']]['report']
          report['careoffice_send_info']['send_type']        = data['send_type']
          report['careoffice_send_info']['send_type_post']   = data['send_type_post']
          report['careoffice_send_info']['send_type_fax']    = data['send_type_fax']
          report['careoffice_send_info']['send_type_email']  = data['send_type_email']
          report['careoffice_send_info']['send_timing']      = data['send_timing']
          report['careoffice_send_info']['send_timing_hour'] = data['send_timing_hour']
          report['careoffice_send_info']['fax']              = data['fax']
          report['careoffice_send_info']['email']            = data['email']
          report['careoffice_send_info']['fusezi_flag']      = data['fusezi_flag']

          var checkOff = true
          if (report['careoffice_send_check'] === true || utils.str2int(report['careoffice_send_check']) === constant.report.send_check) {
            checkOff = false
          }
          if (checkOff) {
            // チェックが付与されていなかったら書換
            report['careoffice_send_type']        = data['send_type']
            report['careoffice_send_type_post']   = data['send_type_post']
            report['careoffice_send_type_fax']    = data['send_type_fax']
            report['careoffice_send_type_email']  = data['send_type_email']
            report['careoffice_send_timing']      = data['send_timing']
            report['careoffice_send_timing_hour'] = data['send_timing_hour']
            report['careoffice_fax']              = data['fax']
            report['careoffice_email']            = data['email']
            report['careoffice_fusezi_flag']      = data['fusezi_flag']
          }
          self.$store.getters.reportEditData[data.patient_index]['report'] = report
        }
        this.$store.dispatch('REPORT_EDIT_CAREOFFICE_SEND_INFO', {data: data, callback: callback})
      }
    },
    getClinicSendInfo: function (report, patientIndex) {
      if (utils.isBlank(report['clinic_id'])) {
        return
      }
      // 報告書種類が 医師に提出 管理対象確認
      if (this.isReportTypeClinicCheck(report)) {
        var data = {
          patient_index:  patientIndex,
          clinic_id:      report['clinic_id'],
          doctor_id:      report['doctor_id'],
          prescribe_date: utils.wareki2Seireki(this.$t, report['prescribe_date'], 'y-m-d') ,
        }
        var self = this
        var callback = function (data) {
          var report = self.$store.getters.reportEditData[data['patient_index']]['report']
          report['clinic_send_info']['send_type']        = data['send_type']
          report['clinic_send_info']['send_type_post']   = data['send_type_post']
          report['clinic_send_info']['send_type_fax']    = data['send_type_fax']
          report['clinic_send_info']['send_type_email']  = data['send_type_email']
          report['clinic_send_info']['send_timing']      = data['send_timing']
          report['clinic_send_info']['send_timing_hour'] = data['send_timing_hour']
          report['clinic_send_info']['fax']              = data['fax']
          report['clinic_send_info']['email']            = data['email']
          report['clinic_send_info']['fusezi_flag']      = data['fusezi_flag']

          var checkOff = true
          if (report['clinic_send_check'] === true || utils.str2int(report['clinic_send_check']) === constant.report.send_check) {
            checkOff = false
          }
          if (checkOff) {
            // チェックが付与されていなかったら書換
            report['clinic_send_type']        = data['send_type']
            report['clinic_send_type_post']   = data['send_type_post']
            report['clinic_send_type_fax']    = data['send_type_fax']
            report['clinic_send_type_email']  = data['send_type_email']
            report['clinic_send_timing']      = data['send_timing']
            report['clinic_send_timing_hour'] = data['send_timing_hour']
            report['clinic_fax']              = data['fax']
            report['clinic_email']            = data['email']
            report['clinic_fusezi_flag']      = data['fusezi_flag']
          }
          self.$store.getters.reportEditData[data.patient_index]['report'] = report
        }
        this.$store.dispatch('REPORT_EDIT_CLINIC_SEND_INFO', {data: data, callback: callback})
      }
    },
    /** 日付一括入力 */
    onBulkDateModalShow: function() {
      this.bulkDate = utils.sereki2Wareki(this.$t, new Date())
      this.bulkDateType = constant.report.bulk_date_type.shohou // 処方日
      // 初期状態
      var elm = document.querySelectorAll('input.bulkDateCheckbox')
      Array.prototype.map.apply(elm, [function (e) {
        e.checked = true
      }])

      var button = document.getElementById('bulk_date_modal_button')
      button.click() // モーダル表示 イベント発火
    },
    setBulkDate: function() {
      // 対象
      var target = []
      var isDeliveryDate = false
      var isPrescribeDate = false
      switch (utils.str2int(this.bulkDateType)) {
        case constant.report.bulk_date_type.shohou:
          target.push('prescribe_date') // 処方日
          target.push('make_date')      // 調剤日
          isPrescribeDate = true
          break
        case constant.report.bulk_date_type.chouzai:
          target.push('make_date') // 調剤日
          break
        case constant.report.bulk_date_type.houmon:
          target.push('delivery_date') // 訪問日
          isDeliveryDate = true
          break
        case constant.report.bulk_date_type.hukuyou:
          target.push('taking_start_date') // 服薬期間
          target.push('deli_start_date')   // 今回 服薬期間
          break
      }
      if (target.length <= 0) {
        return
      }

      var elm = document.querySelectorAll('input.bulkDateCheckbox:checked')
      var data = this.$store.getters.reportEditData
      var bulkDate = this.bulkDate
      var self = this
      Array.prototype.map.apply(elm, [function (e) {
        var idx = e.value
        if (e.checked) {
          for (var i = 0; i < target.length; i++) {
            data[idx]['report'][target[i]] = bulkDate
            if (isDeliveryDate) {
              // 訪問日の場合 介護支援事業所情報再取得
              self.getCareofficeSendInfo(data[idx]['report'], idx)
            }
            if (isPrescribeDate) {
              self.getClinicSendInfo(data[idx]['report'], idx)
            }
          }
        }
      }])
    },

    /** 定型文モーダル表示 設定対象を設定 */
    onPhraseModalShow: function(phraseTarget) {
      // 定型対象
      var type = 'kakunin'
      if (phraseTarget === 'prescribe_change') {
        type = 'henkou' // 変更点
      } else if (phraseTarget === 'soap_comment') {
        type = 'shidou' // 指導内容
      } else {
        type = 'kakunin' // 確認事項
      }
      // data属性に対象を保存
      var modal = document.getElementById('select_phrase_modal')
      if (modal) {
        modal.setAttribute('data-target', phraseTarget)
      }

      // 検索
      var data = {
        'type': type,
      }
      this.$store.dispatch('REPORT_EDIT_SEARCH_PHRASE', {data: data, callback: this.phraseCallback, addList: this.$t('report.phrase_top')})
    },
    /** 定型文設定対象を設定 */
    phraseCallback: function() {
      // 初期化
      if (this.$store.getters.reportEditPhrases && this.$store.getters.reportEditPhrases.length > 0) {
        this.phraseTypeId = this.$store.getters.reportEditPhrases[0]['phrase_type_id']
      }
      this.phraseSort   = 0
      var button = document.getElementById('select_phrase_modal_button')
      button.click() // モーダル表示 イベント発火
    },
    /** 定型文設定対象に設定 */
    onClickSetSelectPhrase: function(phrase_id) {
      var phrases = this.$store.getters.reportEditPhrases
      if (phrases === null) {
        return
      }
      for (var i = 0; i < phrases.length; i++) {
        for (var j = 0; j < phrases[i].phrase.length; j++) {
          var id = utils.str2int(phrases[i].phrase[j]['phrase_id'])
          if (id === utils.str2int(phrase_id)) {
            phrases[i].phrase[j]['active'] = !phrases[i].phrase[j]['active']
          }
        }
      }
    },
    /** 定型文設定対象に設定 */
    setPhraseText: function() {
      // 対象をdata属性から取得
      var modal = document.getElementById('select_phrase_modal')
      var phraseTarget = null
      var maxlength = null
      if (modal) {
        phraseTarget = modal.getAttribute('data-target')
        // 対象テキスト要素から最大入力値を取得
        var elem = document.getElementById(phraseTarget)
        maxlength = utils.str2int(elem.getAttribute('maxlength'))
      }
      if (phraseTarget && maxlength) {
        var elm = document.querySelectorAll('input.phrase_id:checked')
        var texts = []
        var phraseIds = []

        var phrases = this.$store.getters.reportEditPhrases
        if (phrases === null) {
          return
        }
        for (var i = 0; i < phrases.length; i++) {
          for (var j = 0; j < phrases[i].phrase.length; j++) {
            if (phrases[i].phrase[j]['active'] && phraseIds.indexOf(phrases[i].phrase[j]['phrase_id']) === -1) {
              phraseIds.push(phrases[i].phrase[j]['phrase_id'])
              texts.push(phrases[i].phrase[j]['phrase'])
            }
          }
        }

        if (texts.length > 0) {
          var text = '' + texts.join("\n")
          if (text !== '') {
            var blank = "\n"
            if (utils.isBlank(this.report[phraseTarget])) {
              this.report[phraseTarget] = ''
              blank = ''
            }
            // 文字数確認
            var mergeText = this.report[phraseTarget] + blank + text
            if (maxlength >= mergeText.length) {
              // 文字制限内
              this.report[phraseTarget] = mergeText
              // 定型文IDをカウントアップ
              this.$store.dispatch('PHRASE_USE', {data: {phrase_id_list: phraseIds.join(',')}, callback: () => {}})
            } else {
              // 文字数を超えた場合
              var name = ''
              if (phraseTarget === 'prescribe_change') {
                name = this.$t('report.henkouten') // 変更点
              } else if (phraseTarget === 'soap_comment') {
                name = this.$t('report.shidou_naiyou') // 指導内容
              } else {
                name = this.$t('report.kakunin_jikou') // 確認事項
              }
              // 「○○」は○○文字以上入力できません。
              var message = this.$t('messages.maxlength.danger', {name: name, len: maxlength})
              var param = {
                danger: true,
                message: message,
              }
              this.$store.dispatch('REPORT_EDIT_MSG_ALERT', param)
            }
          }
        }
      }
    },

    /** 補助入力 */
    onAutoConsultPoints: function() {
      if (this.$store.getters.reportEditData === null || this.$store.getters.reportEditData.length <= 0) {
        return
      }
      var editData = this.$store.getters.reportEditData
      var patientIndexList = []
      for (var i = 0; i < editData.length; i++) {
        var report = editData[i]['report']
        // 一時保存
        if (report['post_status'] === constant.report.post_status.temp) {
          patientIndexList.push(i)
        }
        // 未送信かつ編集モード
        if (report['post_status'] === constant.report.post_status.no_post && report['edit_mode']) {
          patientIndexList.push(i)
        }
      }
      // 対象なし
      if (patientIndexList.length <= 0) {
        return
      }
      this.$store.dispatch('REPORT_EDIT_AUTO_CONSULT_POINTS', {
        data: {
          'patient_index_list': patientIndexList,
        }
      })
    },

    /** クリアボタン */
    onReportClear: function () {
      if (this.$store.getters.reportEditData !== null && this.$store.getters.reportEditDataBackup !== null) {
        // this.$store.dispatch('REPORT_EDIT_CLEAR', this.patientIndex)

        // this.report['other_no']                                = null  // 他科診察
        this.report['prescribe_date']                          = null  // 処方日
        this.report['make_date']                               = null  // 調剤日
        this.report['ac_clinic_name']                          = null  // クリニックID
        this.report['clinic_name']                             = null  // クリニック
        this.report['clinic_id']                               = null  // クリニックID
        this.report['ac_doctor_name']                          = null  // 医者
        this.report['doctor_name']                             = null  // 医者
        this.report['doctor_id']                               = null  // 医者ID
        this.report['ac_user_name']                            = null  // 作成者
        this.report['user_name']                               = null  // 作成者
        this.report['reportor_id']                             = null  // 作成者ID
        this.report['report_type']                             = ''    // 報告書タイプ
        this.report['clinic_send_check']                       = 0     // クリニック 送付方法
        this.report['clinic_send_type_post']                   = null  // クリニック 郵送/FAX/メール
        this.report['clinic_send_type_fax']                    = null  // クリニック 郵送/FAX/メール
        this.report['clinic_send_type_email']                  = null  // クリニック 郵送/FAX/メール
        this.report['clinic_send_timing']                      = null  // クリニック １週間まとめ送付/２週間まとめ送付
        this.report['clinic_send_timing_hour']                 = null  // クリニック ０分後/３０分後/１時間後～１２時間後
        this.report['clinic_fax']                              = null  // クリニック FAX
        this.report['clinic_email']                            = null  // クリニック メール
        this.report['clinic_fusezi_flag']                      = null  // クリニック 伏字対応
        this.report['clinic_send_info']['send_type_post']      = null  // クリニック 送信情報
        this.report['clinic_send_info']['send_type_fax']       = null  // クリニック 送信情報
        this.report['clinic_send_info']['send_type_email']     = null  // クリニック 送信情報
        this.report['clinic_send_info']['send_timing']         = null  // クリニック 送信情報
        this.report['clinic_send_info']['send_timing_hour']    = null  // クリニック 送信情報
        this.report['clinic_send_info']['fax']                 = null  // クリニック 送信情報
        this.report['clinic_send_info']['email']               = null  // クリニック 送信情報
        this.report['clinic_send_info']['fusezi_flag']         = null  // クリニック 送信情報
        // this.report['careman_id']                              = null  // ケアマネID
        this.report['careoffice_send_check']                   = 0     // 介護支援事業所 送付方法
        this.report['careoffice_send_type_post']               = null  // 介護支援事業所 郵送/FAX/メール
        this.report['careoffice_send_type_fax']                = null  // 介護支援事業所 郵送/FAX/メール
        this.report['careoffice_send_type_email']              = null  // 介護支援事業所 郵送/FAX/メール
        this.report['careoffice_send_timing']                  = null  // 介護支援事業所 １週間まとめ送付/２週間まとめ送付
        this.report['careoffice_send_timing_hour']             = null  // 介護支援事業所 ０分後/３０分後/１時間後～１２時間後
        this.report['careoffice_fax']                          = null  // 介護支援事業所 FAX
        this.report['careoffice_email']                        = null  // 介護支援事業所 メール
        this.report['careoffice_fusezi_flag']                  = null  // 介護支援事業所 伏字対応
        this.report['careoffice_send_info']['send_type_post']  = null  // 介護支援事業所 送信情報
        this.report['careoffice_send_info']['send_type_fax']   = null  // 介護支援事業所 送信情報
        this.report['careoffice_send_info']['send_type_email'] = null  // 介護支援事業所 送信情報
        this.report['careoffice_send_info']['fax']             = null  // 介護支援事業所 送信情報
        this.report['careoffice_send_info']['email']           = null  // 介護支援事業所 送信情報
        this.report['careoffice_send_info']['fusezi_flag']     = null  // 介護支援事業所 送信情報
        this.report['delivery_date']                           = null  // 配達日(訪問日)
        this.report['taking_period']                           = null  // 処方日数
        this.report['taking_start_date']                       = null  // 配薬内容 開始:服用期間
        this.report['taking_start_method']                     = 0     // 配薬内容 開始:服用(朝昼夕就寝)
        this.report['taking_end_date']                         = null  // 配薬内容 終了:服用期間
        this.report['taking_end_method']                       = 0     // 配薬内容 終了:服用(朝昼夕就寝)
        this.report['deli_period']                             = null  // 配達期間
        this.report['deli_start_date']                         = null  // 配達期間 開始:服用期間
        this.report['deli_start_method']                       = 0     // 配達期間 開始:服用(朝昼夕就寝)
        this.report['deli_end_date']                           = null  // 配達期間 終了:服用期間
        this.report['deli_end_method']                         = 0     // 配達期間 終了:服用(朝昼夕就寝)
        this.report['prescribe_change']                        = null  // 処方内容変更点
        this.report['prescribe_check']                         = null  // 変更点 定期薬変更あり 定期薬変更無し 臨時処方
        this.report['soap_comment']                            = null  // 服薬指導
        this.report['taking_status']                           = null  // 服薬状況
        this.report['confirm_comment']                         = null  // 確認事項
        this.report['remnant_status']                          = null  // 残薬状況
        this.report['condition_change']                        = null  // 体調変化
        this.report['side_effect_status']                      = null  // 副作用
        this.report['interaction']                             = null  // 相互作用
        this.report['take_interaction']                        = null  // 服用薬と相互作用のある飲食物の摂取
        this.report['complication']                            = null  // 他科受診、合併症
        this.report['other_dosage']                            = null  // 他科からの投薬
        this.report['otc_combination']                         = null  // ＯＴＣの併用
        this.report['visit_duty']                              = null  // 義務照会
        this.report['dispense_idea']                           = null  // 調剤上の工夫
        this.report['last_request']                            = null  // 後発品の希望
        this.report['medicine_notebook']                       = null  // お薬手帳
        this.report['report_create_time_date']                 = null  // 記入日
        this.report['report_create_time_time']                 = null  // 記入時
        this.report['report_update_time_date']                 = null  // 編集日
        this.report['report_update_time_time']                 = null  // 編集時
      }
    },

    /** 配薬内容リスト表示 */
    onFocusPeriod: function (type) {
      if (type === 'deli') {
        this.isTakingListShow = false                // 配薬内容 処方日数
        this.isDeliListShow   = !this.isDeliListShow // 今回配薬内容 処方日数
      } else {
        this.isTakingListShow = !this.isTakingListShow // 配薬内容 処方日数
        this.isDeliListShow   = false                  // 今回配薬内容 処方日数
      }
    },
    onSetPeriod: function (type, days) {
      if (type === 'deli') {
        // 今回配薬内容
        this.report['deli_period'] = days
      } else {
        this.report['taking_period'] = days
      }
      this.onCalcHaiyakuDate(type)
      setTimeout(() => {
        this.isTakingListShow = false // 配薬内容 処方日数
        this.isDeliListShow   = false // 今回配薬内容 処方日数
      }, 100)
    },
    onBlurPeriod: function () {
      setTimeout(() => {
        this.isTakingListShow = false // 配薬内容 処方日数
        this.isDeliListShow   = false // 今回配薬内容 処方日数
      }, 200)
    },

    /** 配薬期間計算 */
    onCalcHaiyakuDate: function(type) {
      if (utils.isPresent(this.report['taking_period'])) {
        this.report['taking_period'] = utils.double2HalfNumerical(this.report['taking_period'])
      }
      if (utils.isPresent(this.report['deli_period'])) {
        this.report['deli_period'] = utils.double2HalfNumerical(this.report['deli_period'])
      }

      // 配薬内容
      var days       = this.report['taking_period']
      var str_date   = this.report['taking_start_date']
      var str_method = this.report['taking_start_method']
      var end_method = this.report['taking_end_method']
      if (type === 'deli') {
        // 今回配薬内容
        days       = this.report['deli_period']
        str_date   = this.report['deli_start_date']
        str_method = this.report['deli_start_method']
        end_method = this.report['deli_end_method']
      }

      // 必要項目
      if (utils.isBlank(days) && !utils.isNumerical(days) && utils.isBlank(str_date)) {
        return
      }
      // 和暦変換
      str_date = utils.wareki2Seireki(this.$t, str_date)
      if (utils.isBlank(str_date)) {
        return
      }
      // 朝 昼 夕 就寝前
      var minus = null
      var m0 = constant.report.method_type.method_none    // -
      var m1 = constant.report.method_type.method_morning // 朝
      var m2 = constant.report.method_type.method_noon    // 昼
      var m3 = constant.report.method_type.method_evening // 夕
      var m4 = constant.report.method_type.method_bedtime // 就寝前
      if (utils.isPresent(str_method)) {
        str_method = utils.str2int(str_method)
      }
      if (utils.isPresent(end_method)) {
        end_method = utils.str2int(end_method)
      }
      if (utils.isBlank(str_method) || str_method === m0) {
        minus = 1
      } else if (utils.isBlank(end_method) || end_method === m0) {
        minus = 0
      } else {
        if (str_method === m1) {
          // 朝
          minus = 1
        } else if (str_method === m2) {
          // 昼
          switch (end_method) {
            case m1:  // 朝
              minus = 0
              break
            default: // 昼 夕 就寝前
              minus = 1
              break
          }
        }
        else if (str_method === m3) {
          // 夕
          switch (end_method) {
            case m1:  // 朝
            case m2:  // 昼
              minus = 0
              break
            default: // 夕 就寝前
              minus = 1
              break
          }
        }
        else if (str_method === m4) {
          // 就寝前
          switch (end_method) {
            case m1:  // 朝
            case m2:  // 昼
            case m3:  // 夕
              minus = 0
              break
            default: // 就寝前
              minus = 1
              break
          }
        }
      }

      if (minus === null) {
        return
      }

      // 0日
      if (days <= 0) {
        minus = 0
      }

      // 期間を加算 和暦変換
      var end_date = utils.sereki2Wareki(this.$t, utils.dateAddCalc(str_date, 'd', days - minus))

      if (type === 'taking') {
        // 配薬内容
        this.report['taking_end_date'] = end_date
      } else if (type === 'deli') {
        // 今回配薬内容
        this.report['deli_end_date'] = end_date
      }
    },

    /** 医師に提出 押下時のデフォルト */
    onClinicSendCheckDefault: function() {
      if (this.report['clinic_send_check'] === constant.report.send_check || this.report['clinic_send_check'] === true) {
        // if (utils.isBlank(this.report['clinic_send_timing'])) {
        //   this.report['clinic_send_timing'] = constant.report.send_timing.week1 // １週間まとめ送付
        // }
        if (
          this.isSendSendInfoKey(this.report, 'clinic_send_info', false) &&
          utils.isBlank(this.report['clinic_send_type'])        &&
          utils.isBlank(this.report['clinic_send_timing'])      &&
          utils.isBlank(this.report['clinic_send_timing_hour']) &&
          utils.isBlank(this.report['clinic_fax'])              &&
          utils.isBlank(this.report['clinic_email'])            &&
          utils.isBlank(this.report['clinic_fusezi_flag'])
        ) {
          this.report['clinic_send_type']        = this.report['clinic_send_info']['send_type']
          this.report['clinic_send_type_post']   = this.report['clinic_send_info']['send_type_post']
          this.report['clinic_send_type_fax']    = this.report['clinic_send_info']['send_type_fax']
          this.report['clinic_send_type_email']  = this.report['clinic_send_info']['send_type_email']
          this.report['clinic_send_timing']      = this.report['clinic_send_info']['send_timing']
          this.report['clinic_send_timing_hour'] = this.report['clinic_send_info']['send_timing_hour']
          this.report['clinic_fax']              = this.report['clinic_send_info']['fax']
          this.report['clinic_email']            = this.report['clinic_send_info']['email']
          this.report['clinic_fusezi_flag']      = this.report['clinic_send_info']['fusezi_flag']
        }
      }
    },
    onRequireClinicSendCheckChange: function() {
      if (this.report['require_clinic_send'] != 1) {
        this.report['clinic_send_check'] = 0
      }
    },
    /** ケアマネに提出 押下時のデフォルト */
    onCareofficeSendCheckDefault: function() {
      if (this.report['careoffice_send_check'] === constant.report.send_check || this.report['careoffice_send_check'] === true) {
        // if (utils.isBlank(this.report['careoffice_send_timing'])) {
        //   this.report['careoffice_send_timing'] = constant.report.send_timing.week1 // １週間まとめ送付
        // }
        if (
          this.isSendSendInfoKey(this.report, 'careoffice_send_info', false) &&
          utils.isBlank(this.report['careoffice_send_type'])        &&
          utils.isBlank(this.report['careoffice_send_timing'])      &&
          utils.isBlank(this.report['careoffice_send_timing_hour']) &&
          utils.isBlank(this.report['careoffice_fax'])              &&
          utils.isBlank(this.report['careoffice_email'])            &&
          utils.isBlank(this.report['careoffice_fusezi_flag'])
        ) {
          this.report['careoffice_send_type']        = this.report['careoffice_send_info']['send_type']
          this.report['careoffice_send_type_post']   = this.report['careoffice_send_info']['send_type_post']
          this.report['careoffice_send_type_fax']    = this.report['careoffice_send_info']['send_type_fax']
          this.report['careoffice_send_type_email']  = this.report['careoffice_send_info']['send_type_email']
          this.report['careoffice_send_timing']      = this.report['careoffice_send_info']['send_timing']
          this.report['careoffice_send_timing_hour'] = this.report['careoffice_send_info']['send_timing_hour']
          this.report['careoffice_fax']              = this.report['careoffice_send_info']['fax']
          this.report['careoffice_email']            = this.report['careoffice_send_info']['email']
          this.report['careoffice_fusezi_flag']      = this.report['careoffice_send_info']['fusezi_flag']
        }
      }
    },
    onRequireCareofficeSendCheckChange: function() {
      if (this.report['require_careoffice_send'] != 1) {
        this.report['careoffice_send_check'] = 0
      }
    },
    /** 配薬内容コピー */
    onTakingDeliCopy: function(val) {
      this.report['taking_period']       = this.reportHist['taking-period']
      this.report['taking_start_date']   = this.reportHist['taking-start-date']
      this.report['taking_end_date']     = this.reportHist['taking-end-date']
      this.report['taking_start_method'] = this.reportHist['taking-start-method']
      this.report['taking_end_method']   = this.reportHist['taking-end-method']
      this.report['deli_period']         = this.reportHist['deli-period']
      this.report['deli_start_date']     = this.reportHist['deli-start-date']
      this.report['deli_end_date']       = this.reportHist['deli-end-date']
      this.report['deli_start_method']   = this.reportHist['deli-start-method']
      this.report['deli_end_method']     = this.reportHist['deli-end-method']
    },

    /** 変更点 ラジオ */
    onPrescribeChange: function(val) {
      var text = this.report['prescribe_change']
      if (text === '' || text === null) {
        text = val
      } else {
        text = utils.replaceAll(text, "\n" + this.$t('report.prescribe_change.rdo1'), '')
        text = utils.replaceAll(text, "\n" + this.$t('report.prescribe_change.rdo2'), '')
        text = utils.replaceAll(text, "\n" + this.$t('report.prescribe_change.rdo3'), '')
        text = utils.replaceAll(text, this.$t('report.prescribe_change.rdo1'), '')
        text = utils.replaceAll(text, this.$t('report.prescribe_change.rdo2'), '')
        text = utils.replaceAll(text, this.$t('report.prescribe_change.rdo3'), '')
        if (text === '' || text === null) {
          text = val
        } else {
          text += "\n" + val
        }
      }

      // 対象テキスト要素から最大入力値を取得
      var elem = document.getElementById('prescribe_change')
      var maxlength = utils.str2int(elem.getAttribute('maxlength'))
      if (maxlength) {
        if (maxlength >= text.length) {
          // 文字制限内
          this.report['prescribe_change'] = text
        } else {
          // 文字数を超えた場合
          var name = this.$t('report.henkouten') // 変更点
          // 「○○」は○○文字以上入力できません。
          var message = this.$t('messages.maxlength.danger', {name: name, len: maxlength})
          var param = {
            danger: true,
            message: message,
          }
          this.$store.dispatch('REPORT_EDIT_MSG_ALERT', param)
        }
      }
    },

    /** 問題なしボタン */
    onNoProblem: function () {
      this.report['confirm_comment']    = this.$t('report.mondai_nashi')
      this.report['taking_status']      = constant.report.good  // 良
      this.report['remnant_status']     = constant.report.nashi // 無
      this.report['condition_change']   = constant.report.nashi // 無
      this.report['side_effect_status'] = constant.report.nashi // 無
      this.report['interaction']        = constant.report.nashi // 無
      this.report['take_interaction']   = constant.report.nashi // 無
      this.report['complication']       = constant.report.nashi // 無
      this.report['other_dosage']       = constant.report.nashi // 無
      this.report['otc_combination']    = constant.report.nashi // 無
      this.report['visit_duty']         = constant.report.nashi // 無
      this.report['dispense_idea']      = constant.report.nashi // 無
      // this.report['last_request']       = constant.report.nashi // 無
      // this.report['medicine_notebook']  = constant.report.nashi // 無
      this.report['last_request']       = null                  // 無
      this.report['medicine_notebook']  = null                  // 無
    },

    /** 確認事項コピー */
    onConfirmCopy: function () {
      this.report['confirm_comment']    = this.reportHist['confirm-comment']
      this.report['taking_status']      = this.reportHist['taking-status']
      this.report['remnant_status']     = this.reportHist['remnant-status']
      this.report['condition_change']   = this.reportHist['condition-change']
      this.report['side_effect_status'] = this.reportHist['side-effect-status']
      this.report['interaction']        = this.reportHist['interaction']
      this.report['take_interaction']   = this.reportHist['take-interaction']
      this.report['complication']       = this.reportHist['complication']
      this.report['other_dosage']       = this.reportHist['other-dosage']
      this.report['otc_combination']    = this.reportHist['otc-combination']
      this.report['last_request']       = this.reportHist['last-request']
      this.report['visit_duty']         = this.reportHist['visit-duty']
      this.report['dispense_idea']      = this.reportHist['dispense-idea']
      this.report['medicine_notebook']  = this.reportHist['medicine-notebook']
    },

    /** 薬情報クリニック */
    onClickMedicines: function () {
      // 対象テキスト要素から最大入力値を取得
      var elem = document.getElementById('confirm_comment')
      var maxlength = utils.str2int(elem.getAttribute('maxlength'))
      var name = this.$t('report.kakunin_jikou') // 確認事項
      var message = this.$t('messages.maxlength.danger', {name: name, len: maxlength})
      var param = {danger: true, message: message}
      var dispatch = this.$store.dispatch
      var reportTemp = this.report
      // 薬情報を受け取るメソッド
      window.sendMedicinesData = function (data) {
        var text = ''
        if (utils.isBlank(reportTemp['soap_comment'])) {
          text = data
        } else {
          text = reportTemp['soap_comment'] + "\n" + data
        }

        if (maxlength) {
          if (maxlength >= text.length) {
            // 文字制限内
            reportTemp['soap_comment'] = text
          } else {
            // 文字数を超えた場合
            // 「○○」は○○文字以上入力できません。
            dispatch('REPORT_EDIT_MSG_ALERT', param)
          }
        }
      }
      // 薬情報を開く
      var url = location.href
      var div = this.$router.currentRoute.path
      var path = url.substring(0, url.indexOf(div) + 1) + 'medicines?type=select'
      var win = window.open(path, 'window_sub_medicines')
    },

    /** 定期送信モーダル 表示 */
    onClickTeikiModalShow: function(timer) {
      var button = document.getElementById('confirm_teiki_modal_button')
      setTimeout(() => {
        button.click() // モーダル表示 イベント発火
      }, timer)
    },
    /** ヘッダー開閉状態設定 */
    onHeaderOpenClose: function (bool) {
      this.isHeaderOpen = bool
    },

    /** 画像押下 */
    onClickImageModalShow: function () {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = this.patient['avartar-path'] + '?token=' + this.authToken
      text.textContent = ''
      button.click()
    },

    /*******************************************************
     * 確認・状態確認系
     ******************************************************/
    /** 必須チェック */
    requiredCheck: function(report) {
      if (report === null) {
        return true
      }
      var special_comment_format = false
      if (this.plan !== null) {
        // 特記事項・調剤訪問における注意事項
        special_comment_format = utils.isLineFeedCountOver(this.plan['special_comment'], constant.plan.textarea.special_comment)
      }

      var result = {
        report_type:          false,  // 報告書種類
        prescribe_date:       false,  // 処方日
        make_date:            false,  // 調剤日
        delivery_date:        false,  // 訪問日
        clinic_id:            false,  // 医療機関名
        doctor_id:            false,  // 処方医名
        reportor_id:          false,  // 作成者
        prescribe_change:     false,  // 変更点
        soap_comment:         false,  // 指導内容
        confirm_comment:      false,  // 確認事項
        taking_start_method:  false,  // 服薬期間
        taking_end_method:    false,  // 服薬期間
        deli_start_method:    false,  // 今回 服薬期間
        deli_end_method:      false,  // 今回 服薬期間
        taking_status:        false,  // 服薬状況
        remnant_status:       false,  // 残薬
        condition_change:     false,  // 体調変化
        side_effect_status:   false,  // 副作用
        interaction:          false,  // 相互作用
        take_interaction:     false,  // 飲食物
        complication:         false,  // 他科受診
        other_dosage:         false,  // 併用薬
        otc_combination:      false,  // OTC
        last_request:         false,  // 後発希望
        visit_duty:           false,  // 疑義照会
        dispense_idea:        false,  // 調剤工夫
        medicine_notebook:    false,  // お薬手帳
        // 改行
        special_comment_format: special_comment_format // 調剤訪問における注意事項
      }
      if (constant.report.report_type.no_report === report['report_type']) {
        // 報告なし
        return result
      }

      // 報告なし以外
      var is_taking_start_method = false
      var is_taking_end_method   = false
      var is_deli_start_method   = false
      var is_deli_end_method     = false
      var taking_start_method = utils.isBlank(report['taking_start_method']) ? 0 : utils.str2int(report['taking_start_method'])
      var taking_end_method   = utils.isBlank(report['taking_end_method'])   ? 0 : utils.str2int(report['taking_end_method'])
      var deli_start_method   = utils.isBlank(report['deli_start_method'])   ? 0 : utils.str2int(report['deli_start_method'])
      var deli_end_method     = utils.isBlank(report['deli_end_method'])     ? 0 : utils.str2int(report['deli_end_method'])

      // 服薬期間
      if (taking_start_method === 0 && taking_end_method !== 0) {
        is_taking_start_method = true // ng
      } else if (taking_start_method !== 0 && taking_end_method === 0) {
        is_taking_end_method = true // ng
      }
      // 今回 服薬期間
      if (deli_start_method === 0 && deli_end_method !== 0) {
        is_deli_start_method = true // ng
      } else if (deli_start_method !== 0 && deli_end_method === 0) {
        is_deli_end_method = true // ng
      }
      // 有り無し検証
      var ariNashiValid = function (report, key) {
        if (utils.isBlank(report[key])) {
          return true // ng
        }
        if (utils.str2int(report[key]) === 0 || utils.str2int(report[key]) === 1) {
          return false // ok
        }
        return true // ng
      }

      result = {
        report_type:                    utils.isBlank(report['report_type']),        // 報告書種類
        prescribe_date:                 utils.isBlank(report['prescribe_date']),     // 処方日
        make_date:                      utils.isBlank(report['make_date']),          // 調剤日
        delivery_date:                  utils.isBlank(report['delivery_date']),      // 訪問日
        clinic_id:                      utils.isBlank(report['clinic_id']),          // 医療機関名
        doctor_id:                      utils.isBlank(report['doctor_id']),          // 処方医名
        reportor_id:                    utils.isBlank(report['reportor_id']),        // 作成者
        prescribe_change:               utils.isBlank(report['prescribe_change']),   // 変更点
        soap_comment:                   utils.isBlank(report['soap_comment']),       // 指導内容
        confirm_comment:                utils.isBlank(report['confirm_comment']),    // 確認事項
        taking_start_method:            is_taking_start_method,                      // 服薬期間
        taking_end_method:              is_taking_end_method,                        // 服薬期間
        deli_start_method:              is_deli_start_method,                        // 今回 服薬期間
        deli_end_method:                is_deli_end_method,                          // 今回 服薬期間
        taking_status:                  ariNashiValid(report, 'taking_status'),      // 服薬状況
        remnant_status:                 ariNashiValid(report, 'remnant_status'),     // 残薬
        condition_change:               ariNashiValid(report, 'condition_change'),   // 体調変化
        side_effect_status:             ariNashiValid(report, 'side_effect_status'), // 副作用
        interaction:                    ariNashiValid(report, 'interaction'),        // 相互作用
        take_interaction:               ariNashiValid(report, 'take_interaction'),   // 飲食物
        complication:                   ariNashiValid(report, 'complication'),       // 他科受診
        other_dosage:                   ariNashiValid(report, 'other_dosage'),       // 併用薬
        otc_combination:                ariNashiValid(report, 'otc_combination'),    // OTC
        last_request:                   ariNashiValid(report, 'last_request'),       // 後発希望
        visit_duty:                     ariNashiValid(report, 'visit_duty'),         // 疑義照会
        dispense_idea:                  ariNashiValid(report, 'dispense_idea'),      // 調剤工夫
        medicine_notebook:              ariNashiValid(report, 'medicine_notebook'),  // お薬手帳
        // 改行
        prescribe_change_format:        utils.isLineFeedCountOver(report['prescribe_change'], constant.report.textarea.prescribe_change), // 変更点
        soap_comment_format:            utils.isLineFeedCountOver(report['soap_comment'],     constant.report.textarea.soap_comment),     // 指導内容
        confirm_comment_format:         utils.isLineFeedCountOver(report['confirm_comment'],  constant.report.textarea.confirm_comment),  // 指導内容
        // 数字(全角可)
        taking_period_format:           !utils.isNumericalDouble(report['taking_period']), // 処方日数
        deli_period_format:             !utils.isNumericalDouble(report['deli_period']),   // 処方日数
        // 日付
        prescribe_date_format:          !utils.isWareki(this.$t, report['prescribe_date']),          // 処方日
        make_date_format:               !utils.isWareki(this.$t, report['make_date']),               // 調剤日
        delivery_date_format:           !utils.isWareki(this.$t, report['delivery_date']),           // 訪問日
        taking_start_date_format:       !utils.isWareki(this.$t, report['taking_start_date']),       // 服薬期間
        taking_end_date_format:         !utils.isWareki(this.$t, report['taking_end_date']),         // 服薬期間
        deli_start_date_format:         !utils.isWareki(this.$t, report['deli_start_date']),         // 今回 服薬期間
        deli_end_date_format:           !utils.isWareki(this.$t, report['deli_end_date']),           // 今回 服薬期間
        report_create_time_date_format: !utils.isWareki(this.$t, report['report_create_time_date']), // 作成
        report_update_time_date_format: !utils.isWareki(this.$t, report['report_update_time_date']), // 編集
        // 時間
        report_create_time_time_format: !utils.isTime(report['report_create_time_time']), // 作成
        report_update_time_time_format: !utils.isTime(report['report_update_time_time']), // 編集
        // 改行
        special_comment_format: special_comment_format // 調剤訪問における注意事項
      }

      // 報告書種類が 医師に提出 ケアマネに提出 対象確認
      if (this.isReportTypeClinic || this.isReportTypeCareoffice) {
        // 送信チェッククロージャー
        var checkSend = function (prefix, report, result) {
          if (report[prefix + '_send_check'] === true || report[prefix + '_send_check'] === 1) {
            // 送付
            result[prefix + '_send_timing'] = false // ok
            if (utils.isBlank(report[prefix + '_send_timing'])) {
              result[prefix + '_send_timing'] = true // ng
            } else {
              // 当日○時間後送付
              result[prefix + '_send_timing_hour'] = false // ok
              if (utils.str2int(report[prefix + '_send_timing']) === 0 && utils.isBlank(report[prefix + '_send_timing_hour'])) {
                result[prefix + '_send_timing_hour'] = true // ng
              }
            }
            // FAX
            if (utils.isPresent(report[prefix + '_send_type_fax'])) {
              if (report[prefix + '_send_type_fax']) {
                result[prefix + '_fax']          = utils.isBlank(report[prefix + '_fax'])    // FAX
                result[prefix + '_fax_format']   = !utils.isPhone(report[prefix + '_fax'])   // FAX形式
              }
            }
            // メール
            if (utils.isPresent(report[prefix + '_send_type_email'])) {
              if (report[prefix + '_send_type_email']) {
                result[prefix + '_email']        = utils.isBlank(report[prefix + '_email'])  // メール
                result[prefix + '_email_format'] = !utils.isEmail(report[prefix + '_email']) // メール形式
              }
            }
          }
          return result
        }

        // 医師に提出
        if (this.isReportTypeClinicCheck(report, false)) {
          result = checkSend('clinic', report, result)
        }
        // 居宅療養管理指導
        if (this.isReportTypeCareofficeCheck(report, false)) {
          // ケアマネに提出
          result = checkSend('careoffice', report, result)
        }
      }
      return result
    },
    /** 報告書種類が 医師に提出 対象確認 */
    isReportTypeClinicCheck: function (report, isHist) {
      if (report === null) {
        return false
      }
      var key = 'report_type'
      if (isHist) {
        key = 'report-type'
      }
      if (
        report[key] === constant.report.report_type.kyotaku       || // 居宅療養管理指導
        report[key] === constant.report.report_type.yakuzai_kanri || // 在宅患者訪問薬剤管理指導
        report[key] === constant.report.report_type.yaku_shidou   || // かかりつけ薬剤師指導
        report[key] === constant.report.report_type.yaku_houkatsu    // かかりつけ薬剤師包括管理
      ) {
        return true
      }
      return false
    },
    /** 報告書種類が ケアマネに提出 管理対象確認 */
    isReportTypeCareofficeCheck: function (report, isHist) {
      if (report === null) {
        return false
      }
      var key = 'report_type'
      if (isHist) {
        key = 'report-type'
      }
      if (
        report[key] === constant.report.report_type.kyotaku       || // 居宅療養管理指導
        report[key] === constant.report.report_type.yaku_shidou   || // かかりつけ薬剤師指導
        report[key] === constant.report.report_type.yaku_houkatsu    // かかりつけ薬剤師包括管理
      ) {
        return true
      }
      return false
    },
    /** 日付一括の患者リストが編集可能か確認 */
    isBulkDateEditList: function(report) {
      // 送信完了
      if (report['post_status'] === constant.report.post_status.temp) {
        return true
      }
      // 未送信
      if (report['post_status'] === constant.report.post_status.no_post) {
        // 編集モード
        if (this.report['edit_mode']) {
          return true
        }
      }
      // 送信済み
      if (report['post_status'] === constant.report.post_status.post) {
        return true
      }
      return false
    },

    /*******************************************************
     * 値取得
     ******************************************************/
    /** 有/無を取得 */
    getAriNashi: function (idx) {
      if (idx !== null) {
        return this.$t('report.ari_nashi')[idx]
      }
      return ''
    },
    /** 不良/良を取得 */
    getFailureGood: function (idx) {
      if (idx !== null) {
        return this.$t('report.failure_good')[idx]
      }
      return ''
    },
    /** '－', '朝', '昼', '夕', '就寝前'を取得 */
    getMethodName: function (id) {
      if (id !== null) {
        var list = this.$t('report.method_name')
        var name = ''
        for (var i = 0; i < list.length; i++) {
          if (utils.str2int(list[i].id)  === utils.str2int(id)) {
            name = list[i].text
            break
          }
        }
        return name
      }
      return ''
    },
    /** 名称リストを取得 */
    getNameList: function (key) {
      return this.$t(key)
    },

    /** 送信内容のキー存在チェック */
    isSendSendInfoKey: function (report, key, isHist) {
      if (utils.isBlank(report)) {
        return false
      }
      if (Object.keys(report).length <= 0) {
        return false
      }
      if (utils.isBlank(isHist)) {
        isHist = false
      }
      var result = false
      if (key in report) {
        if (utils.isBlank(report[key])) {
          return false
        }
        if (Object.keys(report[key]).length <= 0) {
          return false
        }
        if (isHist) {
          // 履歴
          if (
            ('send-type'        in report[key]) &&
            ('send-type-post'   in report[key]) &&
            ('send-type-fax'    in report[key]) &&
            ('send-type-email'  in report[key]) &&
            ('send-timing'      in report[key]) &&
            ('send-timing-hour' in report[key]) &&
            ('fax'              in report[key]) &&
            ('email'            in report[key]) &&
            ('fusezi-flag'      in report[key])
          ) {
            return true
          }
        } else {
          if (
            ('send_type'        in report[key]) &&
            ('send_type_post'   in report[key]) &&
            ('send_type_fax'    in report[key]) &&
            ('send_type_email'  in report[key]) &&
            ('send_timing'      in report[key]) &&
            ('send_timing_hour' in report[key]) &&
            ('fax'              in report[key]) &&
            ('email'            in report[key]) &&
            ('fusezi_flag'      in report[key])
          ) {
            return true
          }
        }
      }
      return false
    },

    /** 全てのオートコンプリートを消します. */
    autocompleteAllClear: function(param) {
      var time = Object.assign({}, {clinic: 100, doctor: 100, user: 100}, param)
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', time.clinic)
      this.$store.dispatch('DOCTOR_AUTOCOMPLETE_CLEAR', time.doctor)
      this.$store.dispatch('USER_AUTOCOMPLETE_CLEAR', time.user)
    },

    /** url クエリーストリングパラメーターを取得 */
    getQuerystringParams: function (key) {
      if (key in this.$router.currentRoute.params) {
        return this.$router.currentRoute.params[key]
      }
      return null
    },

    /** 有を選択すると指定した文言を自動入力 */
    onRadioButtonStatusTrue: function(title) {
      var statusName = this.$t('report.ari_nashi_name.' + title)
      if (this.report['confirm_comment'] == "") {
        this.report['confirm_comment'] = this.report['confirm_comment'] + statusName + "："
      } else {
        this.report['confirm_comment'] = this.report['confirm_comment'] + "\n" + statusName + "："
      }
    },

    /** 服用期間の開始日時を消すと対象服用期間の項目を消す */
    onClearStartDate: function(val){
      var startDate = val + '_start_date'
      var startMethod = val + '_start_method'
      var endDate = val + '_end_date'
      var endMethod = val + '_end_method'
      if (this.report[startDate] == "") {
        this.report[startMethod] = 0
        this.report[endDate] = ""
        this.report[endMethod] = 0
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/report-edit.js